import { useEffect, useState } from "react";
import { api, fmtINR } from "@/lib/api";

export default function AdminDashboard() {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/admin/dashboard").then((r) => setS(r.data)); }, []);
  return (
    <div>
      <div className="eyebrow">Overview</div>
      <h1 className="font-display text-3xl font-bold mt-2">Command centre</h1>
      <p className="text-stone-500 text-sm">Real-time snapshot of programs, revenue and door activity.</p>

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mt-8">
        <Stat label="Upcoming events" value={s?.upcoming_events ?? "—"} tid="stat-upcoming" />
        <Stat label="Paid bookings" value={s?.paid_bookings ?? "—"} tid="stat-bookings" />
        <Stat label="Revenue" value={s ? fmtINR(s.revenue_paise) : "—"} tid="stat-revenue" accent />
        <Stat label="Check-ins" value={s?.check_ins ?? "—"} tid="stat-checkins" />
      </div>

      <div className="mt-12 cgc-card p-6">
        <div className="eyebrow">Quick start</div>
        <ul className="mt-3 text-sm space-y-2 list-disc pl-5">
          <li>Add Razorpay live keys in <code>backend/.env</code> to go live.</li>
          <li>Add SMTP credentials from Google Workspace to enable email delivery.</li>
          <li>Configure GSTIN and legal name in Settings before printing invoices.</li>
        </ul>
      </div>
    </div>
  );
}

function Stat({ label, value, tid, accent }) {
  return (
    <div data-testid={tid} className={`cgc-card p-5 ${accent ? "bg-[color:var(--brand-terracotta)] text-white border-transparent" : ""}`}>
      <div className={`text-xs font-mono uppercase tracking-widest ${accent ? "opacity-80" : "text-stone-500"}`}>{label}</div>
      <div className="font-display text-3xl font-bold mt-2">{value}</div>
    </div>
  );
}
